/**
 * TanStack Query hooks for `igaming-sim`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingSimQueryKeys,
	type CreateIgamingSimBody,
	type ListIgamingSimResponse,
	type IgamingSimRow,
} from "./api";

export function useIgamingSimList(): UseQueryResult<ListIgamingSimResponse, Error> {
	return useQuery({
		queryKey: igamingSimQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingSimCreate(): UseMutationResult<IgamingSimRow, Error, CreateIgamingSimBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingSimQueryKeys.all });
		},
	});
}

export function useIgamingSimDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingSimQueryKeys.all });
		},
	});
}
